<template>
  <div class="hero-services">
    <div class="row justify-content-center pt-4 m-0">
      <div class="col-12 text-center">
        <h1 class="section-title">
          MŪSŲ PASLAUGOS
        </h1>
      </div>
    </div>
    <div class="row justify-content-center m-5">
      <div class="section-divider"></div>
    </div>
    <div class="row justify-content-center align-items-center m-5 pb-5">
      <div class="col-lg-3 col-md-6 col-sm-7 pb-5">
        <div class="service-card">
          <img src="../../assets/engine.jpeg" class="service-image" alt="Tepalų keitimas">
          <div class="service-overlay">
            <p class="font-weight-bold">Tepalų keitimas</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-7 pb-5">
        <div class="service-card">
          <img src="../../assets/tires.jpeg" class="service-image" alt="Padangų montavimo darbai">
          <div class="service-overlay">
            <p class="font-weight-bold">Padangų montavimo darbai</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-7 pb-5">
        <div class="service-card">
          <img src="../../assets/engine_repair.jpeg" class="service-image" alt="Variklių remontas">
          <div class="service-overlay">
            <p class="font-weight-bold">Variklių remontas</p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-7 pb-5">
        <div class="service-card">
          <img src="../../assets/vaziuokle.jpeg" class="service-image" alt="Važiuoklės remontas">
          <div class="service-overlay">
            <p class="font-weight-bold">Važiuoklės remontas</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
name: "OurServices"
}
</script>

<style scoped>
.hero-services {
  background-color: #f8f9fa;
  padding: 80px 20px;
}

.section-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  padding-top: 40px;
  letter-spacing: -0.02em;
}

.section-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto;
}

.service-card {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.service-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.service-card:hover .service-image {
  transform: scale(1.05);
}

.service-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4), transparent);
  color: white;
  padding: 20px;
  text-align: center;
  transition: background 0.3s ease;
}

.service-card:hover .service-overlay {
  background: linear-gradient(to top, rgba(220, 53, 69, 0.9), rgba(220, 53, 69, 0.6), transparent);
}

.service-overlay p {
  margin: 0;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .service-image {
    height: 200px;
  }
}
</style>